<template>
  <b-card>
    <b-row>
      <b-col cols="12" class="p-0">
        <h2 class="col-md-10 col-lg-10 col-xl-11 mt-1 mb-2" style="color: #1B4332; font-weight: bolder">
          Update Admin
        </h2>
      </b-col>
    </b-row>

    <validation-observer ref="adminForm" v-slot="{ handleSubmit }">
      <b-form @submit.prevent="handleSubmit(onSubmit)">
        <b-row>
          <!-- First Name -->
          <b-col md="6">
            <b-form-group label="First Name">
              <validation-provider name="First Name" rules="required" v-slot="{ errors }">
                <b-form-input
                    v-model="form.first_name"
                    :state="errors.length === 0 ? null : false"
                    placeholder="Enter first name"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Last Name -->
          <b-col md="6">
            <b-form-group label="Last Name">
              <validation-provider name="Last Name" rules="required" v-slot="{ errors }">
                <b-form-input
                    v-model="form.last_name"
                    :state="errors.length === 0 ? null : false"
                    placeholder="Enter last name"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Email -->
          <b-col md="6">
            <b-form-group label="Email">
              <validation-provider name="Email" rules="required|email" v-slot="{ errors }">
                <b-form-input
                    v-model="form.email"
                    type="email"
                    :state="errors.length === 0 ? null : false"
                    placeholder="Enter email"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Admin Type">
              <validation-provider name="Admin Type" rules="required" v-slot="{ errors }">
                <b-form-select
                    v-model="form.admin_type"
                    :options="adminTypeOptions"
                    :state="errors.length === 0 ? null : false"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12" class="d-flex justify-content-between">
            <b-link to="/admin-management">
              <b-button type="button" variant="primary">Back to List</b-button>
            </b-link>
            <b-button type="submit" variant="primary">Update Admin</b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { extend } from 'vee-validate'
import { required, email, min } from 'vee-validate/dist/rules'
import {BLink, BootstrapVueIcons} from 'bootstrap-vue'
import Vue from 'vue'
Vue.use(BootstrapVueIcons)

extend('required', required)
extend('email', email)
extend('min', min)

import axios from 'axios'
import { BCard, BRow, BCol, BForm, BFormGroup, BFormInput, BFormSelect, BButton } from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BLink,
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      form: {
        first_name: '',
        last_name: '',
        email: '',
        admin_type: 'admin_type_a',
      },
      adminTypeOptions: [],
      admin_roles: null,
      id: null
    }
  },
  created() {
    this.getAdminRoles();
    this.id = this.$route.params.id
    this.getAdmin();
  },
  methods: {

    async getAdmin() {
      try {
        const response = await this.$http.post(`/admin-management/${this.id}`)
        const value = response.data.value;

        this.form = {
          first_name: value.first_name,
          last_name: value.last_name,
          email: value.email,
          admin_type: value.type,
        }

      } catch (error) {
        console.error(error)
      }
    },

    async onSubmit() {
      try {
        const response = await this.$http.post(`/admin-management/${this.id}/update`, this.form)
        this.form = {
          first_name: '',
          last_name: '',
          email: '',
          admin_type: 1,
        }

        this.$router.push('/admin-management/').then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Admin Updated successfully',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
        })
      } catch (error) {
        let message = 'Failed to update admin'
        if (error.response && error.response.status === 422) {
          const errors = error.response.data.errors
          message = Object.values(errors).flat().join(', ')
        }

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            text: message,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    },

    getAdminRoles() {
      this.$http.post("/admin-management/get-admin-roles").then((response) => {
        if (response.data.status === 200) {
          this.admin_roles = response.data.value

          this.adminTypeOptions = this.admin_roles.map(role => ({
            value: role.id,
            text: role.role.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) // removing all underscores (_) and making words capitalized
          }))

          if (this.adminTypeOptions.length > 0) {
            this.form.admin_type = this.adminTypeOptions[0].value
          }
        }
      })
    },
  },
}
</script>

<style scoped>
.text-blue {
  color: #007bff;
}
</style>
